/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicSaasCostProcessing extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicSaasCostProcessing");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicSaasCostProcessing.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicSaasCostProcessing>): BackgroundJobPayloadForPeriodicSaasCostProcessing {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicSaasCostProcessing(), model);
        BackgroundJobPayloadForPeriodicSaasCostProcessing.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicSaasCostProcessing>): BackgroundJobPayloadForPeriodicSaasCostProcessing {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicSaasCostProcessing.newInstance(<BackgroundJobPayloadForPeriodicSaasCostProcessing> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicSaasCostProcessing) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicSaasCostProcessing.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicSaasCostProcessing): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicSaasCostProcessing.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
